<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row p-0 align-items-center rental-payment">
              <div class="col mt-4">
                <h4 class="rental-heading">Rental Payments</h4>
              </div>
              <div class="col d-flex justify-content-end">
                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-none d-sm-block new-btn"
                  @click="BackToServices()"
                >
                  Back To Services
                </llp-button>

                <llp-button
                  :load-spinner="showaddadminSpinner"
                  classNames="btn-secondary d-block d-sm-none new-btn"
                  @click="BackToServices()"
                >
                  Go Back
                </llp-button>
              </div>
            </div>
          </div>
        </div>

        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <div class="row rental-payment">
              <div class="col">
                <div class="row mt-4 p-0">
                  <div class="d-flex justify-content-end">
                    <div class="col-lg-1 col-md-1 col-sm-1 rental-btn">
                      <llp-button
                        :load-spinner="payloadSpinner"
                        classNames="btn-secondary new-btn"
                        type="button"
                        @click:button="PayAmount()"
                      >
                        Pay
                      </llp-button>
                    </div>
                    <div
                      class="col-lg-2 col-md-3 col-sm-4"
                      v-if="this.roleId == 4"
                    >
                      <llp-button
                        :load-spinner="showaddUserSpinner"
                        classNames="btn-secondary new-btn"
                        type="button"
                        @click:button="addLandlord()"
                      >
                        <i class="fa-solid fa-plus"></i>
                        Add Landlord
                      </llp-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col position-relative">
                <div v-if="loading" class="loader-overlay">
                  <div class="spinner"></div>
                </div>
                <llp-datatable
                  ref="usersTable"
                  :columns="columns"
                  :data="rentalUser"
                  :lazy="true"
                  :paginator="true"
                  :totalRecords="totalRecords"
                  :rows="perpage"
                  :page="currentPage"
                  scrollable
                  @onPageChange="onPageChange"
                >
                  <template #actions="{ data }">
                    <div class="text-center">
                      <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="ViewRentalDetails(data.id)"
                      >
                        <i class="fa fa-eye"></i>
                        <!-- Eye icon for "View" -->
                      </button>
                      <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="RentalEditDetails(data.id)"
                      >
                        <i class="fa fa-edit"></i>
                      </button>
                      <!-- <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="RentalDeleteDetails(data.id)"
                      >
                        <i class="fa fa-trash"></i>
                      </button> -->
                      <button
                        class="btn btn-secondary m-1 new-btn"
                        @click="PayBill(data.id)"
                      >
                        <i class="fa fa-credit-card"></i>
                      </button>
                    </div>
                  </template>
                </llp-datatable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
// import { mapGetters } from "vuex";
import { useVuelidate } from "@vuelidate/core";
import NetworkService from "@/services/network.service";
// import ErrorService from "../../../services/error.service";

export default {
  setup: () => ({ validator: useVuelidate() }),

  data() {
    return {
      loading: true,
      columns: [
        {
          field: "name",
          className: "text-center",
          header: "Landlord Name",
        },
        {
          field: "address",
          className: "text-center",
          header: "Address",
        },
        {
          header: "Actions",
          body: "actions",
          className: "text-center",
          isCustomized: true,
          customizeName: "actions",
        },
      ],
      showaddadminSpinner: false,
      categoryName: this.$route.params.servicesName,
      serviceId: this.$route.params.serviceId,
      roleId: localStorage.getItem("role_id"),
      userId: localStorage.getItem("User_id"),
      rentalUser: [],
      currentPage: 1,
      perpage: 10,
      totalRecords: 0,
    };
  },

  mounted() {
    this.resetDataTable();
    this.fetchRetalUserDetails();
  },
  watch: {
    "$route.params.roleName": function () {
      this.resetDataTable();
    },
  },
  methods: {
    resetDataTable: function () {
      this.rows = [];
      this.totalRecords = 0;
      this.$refs.usersTable.resetPaginator();
    },
    onPageChange(event) {
      const { first, rows } = event;
      this.currentPage = first / rows + 1;
      this.perpage = rows;
      this.fetchRetalUserDetails(this.currentPage, this.perpage);
    },
    async fetchRetalUserDetails() {
      try {
        const rentalResponseData = await NetworkService.get(
          `get-service-list/${this.userId}/${this.serviceId}?per_page=${this.perpage}&page=${this.currentPage}`
        );
        this.rentalUser = rentalResponseData.details;
        this.totalRecords = rentalResponseData.pagination.total;
        this.loading = false;
      } catch (error) {
        this.loading = false;
       if(error.message)
      {
             this.$refs.toast.show(error.message,"error")
      }else{
          this.$refs.toast.show(
          "Unable to fetching the rental payment user details.",
          "error"
        );
      }
      }
    },
    BackToServices() {
      this.$router.push(`/services`);
    },
    ViewRentalDetails(id) {
      this.$router.push({
        name: "ViewRentalUserDetails",
        params: { serviceId: this.serviceId, id: id },
      });
    },
    RentalEditDetails(id) {
      this.$router.push({
        name: "EditRentalUserDetails",
        params: { serviceId: this.serviceId, id: id },
      });
    },
    // RentalDeleteDetails(id) {
    //   this.$store.dispatch("deleteRentalPayment", id);
    //   this.$refs.toast.show("Rental user is  deleted successfully.", "success");
    // },

    addLandlord() {
      // this.$router.push("/add-rental-payment");
      this.$router.push({
        name: "AddRentalPayment",
        params: { serviceId: this.serviceId },
      });
    },

    PayAmount() {
      this.$router.push({
        name: "PayAmount",
        params: { serviceId: this.serviceId },
      });
    },

    PayBill(id) {
      this.$router.push({
        name: "PayAmount",
        params: { serviceId: this.serviceId, id: id },
      });
    },
  },
};
</script>
